module.exports = __webpack_public_path__ + "img/users-gear.11cf4af0.svg";